<template>
  <q-card
    class="full-width q-my-xs"
    bordered
    :class="props.row.classesForRow()"
    flat
  >
    <q-slide-item
      :ref="'slideItem' + props.row.id"
      :class="props.row.classesForRow()"
      class="q-ma-sm"
      right-color="primary"
      left-color="positive"
      @left="() => $emit('start-payment', props.row)"
    >
      <template
        #right
      >
        <div class="row space-between">
          <q-btn
            icon="cancel"
            class="col"
            round
            @click="() => $refs['slideItem' + props.row.id].reset()"
          />
          <q-btn
            class="col"
            label="Select"
            @click="() => $emit('select-order', props.row)"
          />
          <q-btn
            class="col"
            label="Details"
            @click="() => $emit('view-details', props.row)"
          />
          <q-btn
            class="col"
            label="Void"
            @click="() => $emit('start-void', props.row)"
          />
        </div>
      </template>
      <template
        #left
      >
        <q-icon
          name="payment"
        />
      </template>
      <component
        :is="OrderStateCell"
        v-bind="{ props: props }"
      />
      <q-chip>
        {{ $t('pricing.total') }}:&nbsp; <i18n-n
          :value="props.row.total"
          format="currency"
        />
      </q-chip>
      <q-chip v-if="props.row.name">
        {{ props.row.name }}
      </q-chip>
      <q-chip v-if="props.row.registerStation">
        {{ props.row.registerStation.name }}
      </q-chip>
      <q-chip v-if="props.row.employee">
        {{ props.row.employee.firstName }} {{ props.row.employee.lastName }}
      </q-chip>
      <div class="row">
        <div class="col row">
          <q-chip
            v-for="item in props.row.id === expandId ? props.row.orderItems.data : $_.take(props.row.orderItems.data, 2)"
            :key="item.id"
            square
            style="max-width: 95%;"
            class="col-auto ellipsis"
          >
            {{ item.description }}
          </q-chip>
        </div>
        <q-btn
          v-if="props.row.orderItems.data.length > 2"
          class="col-auto"
          dense
          :icon="expandId === props.row.id ? 'expand_less' : 'expand_more'"
          @click.stop="expandId === props.row.id ? expandId = null : expandId = props.row.id"
        />
      </div>
    </q-slide-item>
  </q-card>
</template>

<script>
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'OrderTableGrid',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  emits: ['start-payment', 'select-order', 'view-details', 'start-void'],
  data () {
    return {
      expandId: null
    }
  },
  created () {
    _.extend(this, {
      OrderStateCell
    })
  }
}
</script>
